<script type="text/javascript">
	import {get} from "svelte/store";
	import MenuItem from "../UI/FlyoutMenu/MenuItem.svelte";
	import CustomMapDatasets from "./CustomMapDatasets"
	import CustomMapDatasetType from "./CustomMapDatasetType"
	import "../UI/AlertFilters/AlertFilters.scss";

	import FiltersComponent from "../Filters/FiltersComponent.svelte";
	import StringHelper from "../Helpers/StringHelper";

	import List, {Group, Item, Graphic, Meta, Label, Separator, Subheader, Text, PrimaryText, SecondaryText} from '@smui/list';
	import Menu, {SelectionGroup, SelectionGroupIcon} from "@smui/menu";
	import IconButton, {Icon} from "@smui/icon-button"
	import Textfield, {Input, Textarea} from "@smui/textfield";
import FiltersButtonMenu from "../Filters/FiltersButtonMenu.svelte";

	let lastUpdated = CustomMapDatasets.lastUpdated;
	let datasets = [];
	$: {
		$lastUpdated;
		update();
	}
	let update = () => {
		datasets = Object.values(CustomMapDatasets.data);
	};
</script>

{#each datasets as dataset, index}
	{#if dataset.public}

		<MenuItem title={dataset.name} class="filters-component" materialIcon={dataset.icon}>
			<div slot="context-menu">
				<FiltersButtonMenu filters={dataset.filters} hackStyle={"left:-152px;"}/>
			</div>
			<div class="content" style='margin-top: 0px;'>
				{#if dataset.type === CustomMapDatasetType.POINTS}
					<p style="display:none;"></p>
				{:else if dataset.type === CustomMapDatasetType.MULTIPOLYGON_GRADIENT}
					{#if dataset.layerPaintProperties && dataset.layerPaintProperties.length > 0}
						<h2>Visualise By:</h2>
						<select class='default' value={get(dataset.layerPaintProperty)} on:change={(e)=>{
							dataset.layerPaintProperty.set(e.target.value);
						}} style='margin-bottom:10px;' >
							{#each dataset.layerPaintProperties as property}
								<option value={property}>{StringHelper.replaceAll(property, "_", " ")}</option>
							{/each}
						</select>
					{/if}
					<h2>Visualise By - Colour Scale - Max Value ($/day):</h2>
					<input type='text' value={get(dataset.layerPaintFillColorMaxValue)} style='margin-bottom:10px;'   on:change={(e) => {
							dataset.layerPaintFillColorMaxValue.set(e.target.value);
						}}
						on:keyup={(e)=>{
							dataset.layerPaintFillColorMaxValue.set(e.target.value);
						}} />
				{/if}

				<FiltersComponent name={"custom-"+index} filters={dataset.filters} on:update={()=>{ update() }} />
			</div>
		</MenuItem>
	{/if}
{/each}
